import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getDataWaiver = 'master-waiver';
const postDataWaiver = 'master-waiver';
const putDataWaiver = 'master-waiver/';
const deleteDataWaiver = 'master-waiver/';

class WaiverService {

    getDataWaiver(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getDataWaiver + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            }
        )
    }

    postDataWaiver(formdata) {
        return axios.post(API_URL + postDataWaiver, formdata, {
            headers: authHeader()
        });
    }

    putDataWaiver(formdata) {
        return axios.put(API_URL + putDataWaiver + formdata.idWaiver, formdata, {
            headers: authHeader()
        });
    }

    deleteDataWaiver(formdata) {
        return axios.delete(API_URL + deleteDataWaiver + formdata.idWaiver, {
            headers: authHeader()
        });
    }

}


export default new WaiverService();